(function () {
  var SLIDER_ARROW_PREV =
    '<img class="prev-arr" src="https://cdn.shopify.com/s/files/1/0917/0360/7679/files/left-chevron.png?v=1748863478">';
  var SLIDER_ARROW_NEXT =
    '<img class="next-arr" src="https://cdn.shopify.com/s/files/1/0917/0360/7679/files/chevron.png?v=1748863478">';

  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, delay);
    };
  }

  function initSlickSliders(root) {
    if (!window.jQuery || !jQuery.fn || !jQuery.fn.slick) return;

    var $scope = root && root.nodeType ? jQuery(root) : jQuery(document);
    $scope.find('.slide-image').removeClass('more_than_one');

    $scope.find('.cust-slick').each(function () {
      var $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) return;
      $slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow: SLIDER_ARROW_PREV,
        nextArrow: SLIDER_ARROW_NEXT
      });
    });

    $scope.find('.collection-slick').each(function () {
      var $slider = jQuery(this);
      if ($slider.hasClass('slick-initialized')) return;
      $slider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        prevArrow: SLIDER_ARROW_PREV,
        nextArrow: SLIDER_ARROW_NEXT
      });
    });
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    return new Promise(function (resolve, reject) {
      try {
        var input = document.createElement('input');
        input.value = text;
        document.body.appendChild(input);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  function fadeTooltip(tooltip) {
    if (!tooltip) return;

    tooltip.style.display = 'block';
    tooltip.style.opacity = '1';
    window.setTimeout(function () {
      tooltip.style.opacity = '0';
      window.setTimeout(function () {
        tooltip.style.display = '';
        tooltip.style.opacity = '';
      }, 200);
    }, 300);
  }

  function toggleSiblingSubmenu(trigger) {
    if (!trigger) return;

    var menuItem = trigger.closest('.menu-drawer__menu-item');
    var submenu = menuItem ? menuItem.nextElementSibling : null;
    trigger.classList.toggle('active');
    if (submenu) {
      submenu.style.display = submenu.style.display === 'block' ? 'none' : 'block';
    }
  }

  function handleVariantHover(image, isEntering) {
    if (!image) return;

    var card = image.closest('.card');
    var targetImage = card ? card.querySelector('.card__media .media img') : null;
    if (!targetImage) return;

    if (isEntering) {
      if (!targetImage.dataset.originalSrcset) {
        targetImage.dataset.originalSrcset = targetImage.getAttribute('srcset') || '';
        targetImage.dataset.originalSrc = targetImage.getAttribute('src') || '';
      }

      var variantImage = image.getAttribute('src');
      if (variantImage) {
        targetImage.setAttribute('srcset', variantImage);
        targetImage.setAttribute('src', variantImage);
      }
      return;
    }

    if (targetImage.dataset.originalSrcset) targetImage.setAttribute('srcset', targetImage.dataset.originalSrcset);
    if (targetImage.dataset.originalSrc) targetImage.setAttribute('src', targetImage.dataset.originalSrc);
  }

  function bindInteractions() {
    if (document.documentElement.dataset.themeEnhancementsBound === 'true') return;
    document.documentElement.dataset.themeEnhancementsBound = 'true';

    document.addEventListener('click', function (event) {
      var copyButton = event.target.closest('#copy_coun_code');
      if (copyButton) {
        copyText((document.getElementById('copy-content') || {}).textContent || '').then(function () {
          fadeTooltip(document.querySelector('.tooltip'));
        });
        return;
      }

      var tabButton = event.target.closest('.mobile_tab_btn .mob_cat_btn');
      if (tabButton) {
        var container = tabButton.closest('.mobile_tab_btn');
        var content = container ? container.nextElementSibling : null;
        var tabId = tabButton.getAttribute('tabid');

        if (container) {
          container.querySelectorAll('.mob_cat_btn').forEach(function (button) {
            button.classList.remove('active');
          });
        }
        tabButton.classList.add('active');

        if (content) {
          content.querySelectorAll('.mobile_cat_one').forEach(function (panel) {
            panel.style.display = panel.getAttribute('data-desc-id') === tabId ? '' : 'none';
          });
        }
        return;
      }

      var menuToggle = event.target.closest('.custom_menu_mobile_drawer nav.menu-drawer__navigation ul li span.svg-wrapper');
      if (menuToggle) {
        toggleSiblingSubmenu(menuToggle);
        return;
      }

      var menuLink = event.target.closest('.custom_menu_mobile_drawer a.main_menu_url');
      if (menuLink) {
        var href = menuLink.getAttribute('href');
        if (!href || href === '#') {
          event.preventDefault();
          toggleSiblingSubmenu(menuLink.parentElement ? menuLink.parentElement.querySelector('span.svg-wrapper') : null);
        }
        return;
      }

      var closeIcon = event.target.closest('header-drawer .mobile_menu_close svg');
      if (closeIcon) {
        var opener = closeIcon.closest('.menu-drawer-container.menu-opening');
        var button = opener ? opener.querySelector('.header__icon') : null;
        button && button.click();
        return;
      }

      var mobileSearch = event.target.closest('.mobile_search_icon');
      if (mobileSearch) {
        mobileSearch.classList.toggle('active');
        var search = document.querySelector('header.header+nav+.rps-csb-container-new');
        var logo = document.querySelector('.header__heading-logo-wrapper');

        if (search) search.style.display = mobileSearch.classList.contains('active') ? 'block' : 'none';
        if (logo) logo.style.display = mobileSearch.classList.contains('active') ? 'none' : 'block';
        return;
      }

      var galleryWishlist = event.target.closest('.product-gallery__wishlist');
      if (galleryWishlist) {
        event.stopPropagation();
      }
    });

    document.addEventListener('mouseover', function (event) {
      var variantImage = event.target.closest('.custom_color_variant img');
      if (variantImage) handleVariantHover(variantImage, true);
    });

    document.addEventListener('mouseout', function (event) {
      var variantImage = event.target.closest('.custom_color_variant img');
      if (!variantImage) return;
      if (event.relatedTarget && variantImage.contains(event.relatedTarget)) return;
      handleVariantHover(variantImage, false);
    });
  }

  function updateMenuDrawerTop() {
    var announcementBar = document.querySelector('.announcement-bar');
    var headerHeight = announcementBar ? announcementBar.offsetHeight : 0;

    document.querySelectorAll('header.header details#Details-menu-drawer-container div#menu-drawer').forEach(function (drawer) {
      drawer.style.top = '-' + headerHeight + 'px';
    });
  }

  function reinitVerticalThumbnailSliders() {
    if (window.innerWidth <= 1000) return;

    document.querySelectorAll('.product__column-sticky .thumbnail-slider').forEach(function (slider) {
      if (slider && typeof slider.resetPages === 'function') {
        window.requestAnimationFrame(function () {
          slider.resetPages();
        });
      }
    });
  }

  function initHeaderHoverMenus() {
    var inlineMenu = document.querySelector('.header__inline-menu');
    if (!inlineMenu) return;

    inlineMenu.querySelectorAll('details').forEach(function (item) {
      if (item.dataset.hoverBound === 'true') return;
      item.dataset.hoverBound = 'true';

      item.addEventListener('mouseover', function () {
        item.setAttribute('open', 'true');
      });

      item.addEventListener('mouseleave', function () {
        item.removeAttribute('open');
      });

      var list = item.querySelector('ul');
      if (list) {
        list.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
      }
    });
  }

  function initAll(root) {
    initSlickSliders(root);
    updateMenuDrawerTop();
    initHeaderHoverMenus();
    setTimeout(reinitVerticalThumbnailSliders, 100);
  }

  window.themeEnhancementsInitAll = initAll;

  document.addEventListener('DOMContentLoaded', function () {
    bindInteractions();
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  window.addEventListener(
    'resize',
    debounce(function () {
      updateMenuDrawerTop();
      reinitVerticalThumbnailSliders();
    }, 250)
  );

  window.addEventListener('load', function () {
    initAll(document);
  });
})();
